<div class="profile-grid">
  @if (rows.length) {
    <section class="pcard full-width setup-card" aria-live="polite">
      <h2><nb-icon icon="alert-circle-outline"></nb-icon><span>{{ 'companytabs.setup_title' | translate }}</span></h2>
      <ul class="setup-rows">
        @for (row of rows; track row.tab) {
          <li>
            <a [routerLink]="['/company', row.tab]" (click)="open(row.fields[0])">
              <span class="setup-tab">{{ 'companytabs.' + row.tab | translate }}</span>
              <span class="setup-fields">@for (f of row.fields; track f) {{{ labels[f] | translate }}@if (!$last) {, }}</span>
              <nb-icon icon="arrow-forward-outline" aria-hidden="true"></nb-icon>
            </a>
          </li>
        }
      </ul>
    </section>
  }
  @switch (tab) {
    @case ('billing') {
      <section class="pcard full-width">
        <h2><nb-icon icon="credit-card-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.company.hint' | translate" [attr.aria-description]="'invoicing.company.hint' | translate">{{ 'invoicing.company.title' | translate }}</span></h2>
        <bst-invoicing-company section="billing"></bst-invoicing-company>
      </section>
    }
    @case ('vat') {
      <section class="pcard full-width">
        <h2><nb-icon icon="percent-outline"></nb-icon><span>{{ 'invoicing.company.vat_id' | translate }}</span></h2>
        <bst-invoicing-company section="vat"></bst-invoicing-company>
      </section>
      <section class="pcard full-width">
        <h2><nb-icon icon="percent-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.vat.hint' | translate" [attr.aria-description]="'invoicing.vat.hint' | translate">{{ 'invoicing.vat.title' | translate }}</span></h2>
        <bst-vat-options></bst-vat-options>
      </section>
    }
    @case ('kilometres') {
      <section class="pcard full-width">
        <h2><nb-icon icon="car-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'invoicing.km.hint' | translate" [attr.aria-description]="'invoicing.km.hint' | translate">{{ 'invoicing.km.title' | translate }}</span></h2>
        <bst-km-cost-type></bst-km-cost-type>
      </section>
    }
    @case ('reimbursement') {
      <section class="pcard full-width">
        <h2><nb-icon icon="person-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'reimbursementrate.hint' | translate" [attr.aria-description]="'reimbursementrate.hint' | translate">{{ 'reimbursementrate.title' | translate }}</span></h2>
        <bst-reimbursement-rates></bst-reimbursement-rates>
      </section>
    }
    @case ('quotes') {
      <section class="pcard full-width">
        <h2><nb-icon icon="file-text-outline"></nb-icon><span class="hint-tip" tabindex="0" [nbTooltip]="'quotes.settings.hint' | translate" [attr.aria-description]="'quotes.settings.hint' | translate">{{ 'quotes.settings.title' | translate }}</span></h2>
        <bst-quote-settings></bst-quote-settings>
      </section>
    }
  }
</div>
